module.exports = __webpack_public_path__ + "static/icon_sprite-2c746c94517f6dcaa565c659c11e78f8.png";